import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import Statement from 'src/feature/statement/view'
import {useStore} from 'src/feature/store/hook'

const StoreInvoices = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detail, detailSet, tabFilter, tabFilterSet} = useStore()

  const Data = detail?.Invoice?.dataList || []
  const paging = detail?.Invoice?.paging || {
    currentPageNumber: 1,
    totalPagesNumber: 0,
    pageSize: 1,
    totalCount: 0,
  }

  const Columns = [
    {
      title: intl.formatMessage({id: 'STORE.DETAIL.OVERVIEW.INVOICE_ISSUER'}),
      key: 'invoiceIssuerName',
      dataIndex: 'invoiceIssuerName',
      // edit: 'select', formName: 'isoid',
      // selects: isoList?.map((item: any) => ({ value: item.id, text: item.name })),
    },
    {
      key: 'InvoiceNo',
      dataIndex: 'invoiceNo',
      title: intl.formatMessage({id: 'STORE.DETAIL.INVOICES.INVOICE_NO'}),
    },
    {
      key: 'Date',
      dataIndex: 'date',
      title: intl.formatMessage({id: 'STORE.DETAIL.INVOICES.DATE'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'Amount',
      dataIndex: 'amount',
      title: intl.formatMessage({id: 'STORE.DETAIL.INVOICES.AMOUNT'}) + ' ($)',
      render: (text: any) => <>{text.toFixed(2)}</>,
    },
    {
      key: 'DiscountAmount',
      dataIndex: 'discountedAmount',
      title: intl.formatMessage({id: 'STORE.DETAIL.INVOICES.DISCOUNT_AMOUNT'}) + ' ($)',
      render: (text: any) => <>{text.toFixed(2)}</>,
    },
    // {
    //   key: 'PaidAmount', dataIndex: 'paidAmount',
    //   title: intl.formatMessage({ id: 'STORE.DETAIL.INVOICES.PAID_AMOUNT' }),
    //   render: (text: any) => <>{text.toFixed(2)}</>
    // },
    {
      key: 'PaymentType',
      dataIndex: 'paymentType',
      title: intl.formatMessage({id: 'STORE.DETAIL.INVOICES.PAYMENT_TYPE'}),
      render: (text: any) => {
        let type = ''

        switch (text) {
          case 0:
            type = 'Cash'
            break
          case 1:
            type = 'Credit Card'
            break
          case 699:
            type = 'Points'
            break
          default:
            type = '-'
            break
        }

        return <>{type}</>
      },
    },
  ]

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <div>
              <h3 className='fw-bold mb-2 mt-5'>
                {intl.formatMessage({id: 'STORE.DETAIL.INVOICES'})}
              </h3>
              <p className='text-muted fw-normal fs-6'>
                {intl.formatMessage({id: 'STORE.DETAIL.INVOICES_TOOLTIP'})}
              </p>
            </div>
          </div>
        </div>

        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <Table
              loading={loading}
              dataSource={Data}
              columns={Columns}
              pagination={{
                current: paging.currentPageNumber,
                pageSize: paging.pageSize,
                total: paging.totalCount,
                onChange: (page: any) => {
                  if (!detail || !detail.Invoice) return
                  const {pageSize, current} = page
                  const currentPage = pageSize !== detail.Invoice.paging.pageSize ? 1 : current

                  detailSet({
                    ...detail,
                    Invoice: {
                      ...detail.Invoice,
                      paging: {
                        ...paging,
                        currentPageNumber: currentPage,
                        pageSize: pageSize,
                      },
                    },
                  })

                  tabFilterSet({
                    ...tabFilter,
                    paging: {
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  })
                },
              }}
            />
          </div>
        </div>
      </div>

      {/* <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>{intl.formatMessage({id: 'MENU.STATEMENT'})}</h3>
          </div>
        </div>
        <div className='card-body pt-0'>
          <Statement />
        </div>
      </div> */}
    </>
  )
}

export default StoreInvoices
